import React, { Component } from 'react'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import StyleSheet from 'styles'
import IconButton from '@material-ui/core/IconButton'
import { connect } from 'react-redux'
import { CountryActions, CountryGroupActions } from 'actionsets'
import {Pagination, ErrorBox, SearchComboInput, TextField} from 'components'
import Typography from '@material-ui/core/Typography'
import Dependent from 'containers/shared/Dependent'
import DeleteIcon from '@material-ui/icons/Delete'
import ViewIcon from '@material-ui/icons/RemoveRedEye'
import EditIcon from '@material-ui/icons/Create'
import CountryGroupIcon from '@material-ui/icons/GroupWork';
import CountryIcon from '@material-ui/icons/PinDrop';
import Button from '@material-ui/core/Button'
import CenteredContent from 'containers/CenteredContent'
import {connectQueryString} from 'containers/shared'

export class CountriesList extends Component {

  constructor(props) {
    super(props)
    CountryActions.bindActions(this, 'countries')
    CountryGroupActions.bindActions(this, 'countryGroups')
    this.state = {countriesCurrentPage: 1, countryGroupsCurrentPage: 1}
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.query !== this.props.query)
      return this.loadData()
  }

  dependsOn() {
    this.loadData()
  }

  dependenciesMet() {
    return (
      this.props.countries.requests.filter(r => r.type === CountryActions.INDEX).length === 0 &&
      this.props.countryGroups.requests.filter(r => r.type === CountryActions.INDEX).length === 0
    )
  }

  loadData = () => {
    const {filter, page, order} = this.props
    return Promise.all([
      this.actions.countries.index({filter, page, order}),
      this.actions.countryGroups.index(this.state.currentPage)
    ])
  }

  get countriesTotalPages() {
    return this.props.countries.totalPages || 0
  }

  get countryGroupsTotalPages() {
    return this.props.countryGroups.totalPages || 0
  }

  get countriesCurrentPage() {
    return this.state.countriesCurrentPage
  }

  get countryGroupsCurrentPage() {
    return this.state.countryGroupsCurrentPage
  }

  get countries() {
    return this.props.countries.countries
  }

  get countryGroups() {
    return this.props.countryGroups.countryGroups
  }

  set countriesCurrentPage(value) {
    this.setState({
      countriesCurrentPage: value
    })
    this.actions.countries.index(value)
  }

  set countryGroupsCurrentPage(value) {
    this.setState({
      countryGroupsCurrentPage: value
    })
    this.actions.countryGroups.index(value)
  }

  handleShowCountryGroup = id => () => {
    this.props.history.push(`/country_groups/${id}`)
  }

  handleEditCountry = id => () => {
    this.props.history.push(`/countries/${id}/edit`)
  }

  handleEditCountryGroup = id => () => {
    this.props.history.push(`/country_groups/${id}/edit`)
  }

  handleDeleteCountry = id => async () => {
    await this.actions.countries.destroy({id})
    this.actions.countries.index(this.state.currentPage)
  }

  handleDeleteCountryGroup = id => async () => {
    await this.actions.countryGroups.destroy({id})
    this.actions.countryGroups.index(this.state.currentPage)
  }

  handleNewCountry = () => {
    this.props.history.push(`/countries/new`)
  }

  handleNewCountryGroup = () => {
    this.props.history.push(`/country_groups/new`)
  }

  renderCountry = ({id, name, supported}) =>
    <ListItem className={styles({listItem: true, supported: !!supported})} key={id} onClick={this.handleEditCountry(id)}>
      <ListItemIcon>
        <CountryIcon/>
      </ListItemIcon>
      <ListItemText className={styles.listItemText} primary={name}/>
      <ListItemSecondaryAction>
        <IconButton aria-label='Delete' onClick={this.handleDeleteCountry(id)}>
          <DeleteIcon/>
        </IconButton>
        <IconButton aria-label="edit" onClick={this.handleEditCountry(id)}>
          <EditIcon/>
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>

  renderCountryGroup = ({id, name}) =>
    <ListItem className={styles.listItem} key={id} onClick={this.handleShowCountryGroup(id)}>
      <ListItemIcon>
        <CountryGroupIcon/>
      </ListItemIcon>
      <ListItemText className={styles.listItemText} primary={name}/>
      <ListItemSecondaryAction>
        <IconButton aria-label='Delete' onClick={this.handleDeleteCountryGroup(id)}>
          <DeleteIcon/>
        </IconButton>
        <IconButton aria-label="view" onClick={this.handleShowCountryGroup(id)}>
          <ViewIcon/>
        </IconButton>
        <IconButton aria-label="edit" onClick={this.handleEditCountryGroup(id)}>
          <EditIcon/>
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>

  render = () => {
    const {onFilterChange, filter, onPageChange, page} = this.props
    return (
      <CenteredContent>
        <div className={styles.listWrapper}>
          <ErrorBox errors={this.props.countryGroups.errors}/>
          <Button variant='contained' color='primary' onClick={this.handleNewCountryGroup} className={styles.add}>
            Create
          </Button>
          <Typography variant='h5' className={styles.headline}>Country Groups</Typography>
          <Pagination className={styles.pagination} totalPages={this.countryGroupsTotalPages}
                      page={this.countryGroupsCurrentPage}
                      onPageSelected={(page) => this.countryGroupsCurrentPage = page}/>
          <List className={styles.list}>
            {this.countryGroups.map(this.renderCountryGroup)}
            {!this.countryGroups.length &&
            <Typography className={styles.noResultsMessage}>No Country Groups</Typography>}
          </List>
          <Pagination className={styles.pagination} totalPages={this.countryGroupsTotalPages}
                      page={this.countryGroupsCurrentPage}
                      onPageSelected={(page) => this.countryGroupsCurrentPage = page}/>
        </div>
        <div className={styles.listWrapper}>
          <ErrorBox errors={this.props.countries.errors}/>
          <Button variant='contained' color='primary' onClick={this.handleNewCountry} className={styles.add}>
            Create
          </Button>
          <Typography variant='h5' className={styles.headline}>Countries</Typography>
          <SearchComboInput onFilterChange={onFilterChange} filter={filter} searchTextMember="name">
            <div>
              <TextField member="name" />
            </div>
          </SearchComboInput>
          <Pagination className={styles.pagination} totalPages={this.countriesTotalPages}
                      page={page} onPageSelected={onPageChange}/>
          <List className={styles.list}>
            {this.countries.map(this.renderCountry)}
            {!this.countries.length &&
            <Typography className={styles.noResultsMessage}>No Countries</Typography>}
          </List>
          <Pagination className={styles.pagination} totalPages={this.countriesTotalPages}
                      page={this.countriesCurrentPage}
                      onPageSelected={(page) => this.countriesCurrentPage = page}/>
        </div>
      </CenteredContent>
    )
  }
}

const styles = StyleSheet({
  headline: {
    flex: 1,
    marginBottom: 10
  },
  errorBox: {
    borderLeft: '4px solid #ad1010',
    padding: 10,
    background: '#f93f3f',
    color: '#d23232',
    margin: 10,
  },
  pagination: {
    padding: 5
  },
  noResultsMessage: {
    padding: 20,
    background: '#f6f6f6',
    fontWeight: 'bold'
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  content: {
    position: 'relative'
  },
  add: {
    float: 'right'
  },
  list: {
    margin: 0,
    paddingTop: 20,
    paddingBottom: 26,
    marginBottom: 30,
  },
  listWrapper: {
    position: 'relative',
    paddingBottom: 24
  },
  card: {
    flex: 1,
    minWidth: 300,
    alignSelf: 'flex-start',
    margin: 10,
    maxWidth: 1200
  },
  listItem: {
    cursor: 'pointer',
    '&$supported': {
      background: '#ddd',
      '&:hover': {
        background: '#e6e6e6'
      }
    },
    '&:hover': {
      background: '#f6f6f6'
    }
  },
  supported: {},
  '@media(max-width: 600px)': {
    listItemText: {
      cursor: 'pointer',
      '& h6': {
        fontSize: 13
      }
    }
  }
})

export default connect(({countries, countryGroups}) => ({countries, countryGroups}))(connectQueryString(Dependent({loader: true, wrapperClassName: styles.wrapper})(CountriesList)))